<script setup lang="ts">
import LegacyConfigurator from "@/components/Configurator/index.vue";
import Page404 from "@/university/views/404Page.vue";
import { useRegistrationOptions } from "../composables/useRegistrationOptions.ts";

defineOptions({
  name: "RegistrationBridge",
});

const { isLegacy, isLegacyOrderLoading } = useRegistrationOptions();
</script>

<template>
  <LegacyConfigurator v-if="isLegacy" />
  <Page404 v-else />
</template>
